/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { Badge, Box } from '@mui/material';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  ArrowBackIos,
  AddCircleOutline,
  Tune,
  Visibility
} from '@mui/icons-material';
import { DataTable } from 'primereact/datatable';
import { useLocation, useNavigate } from 'react-router-dom';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { LoadingRowsComponent } from '../../../components/commons/LoadingRows/LoadingRows';
import {
  ButtonIconStyled,
  SharedWithItem,
  StatusProcess,
  StyledButtonName
} from './allLocationListStyles';
import { Location, LocationByUser } from '../../../types/location/location';
import { setAllLocations } from '../../../store/slices/locations/location';
import { useGetLocationsMutation } from '../../../services/device/deviceService';
import Strings from '../../../i18n';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { AddLocationBar } from '../addLocationBar/addLocationBar';
import { Header } from '../../../components/header/header';
import { ContainerStyled } from '../../../views/locations/locationStyles';
import { TitleStyled } from '../../../views/devices/devicesStyles';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { LocationDetailsBar } from '../locationDetailsBar/locationDetailsBar';
import { ShareLocationBar } from '../shareLocationBar/shareLocationBar';
import { TransferLocationBar } from '../transferLocationBar/transferLocationBar';
import { MoveLocationBar } from '../moveLocationBar/moveLocationBar';
import { MultipleLocationsDetailsSideBar } from '../multipleLocationsDetails/multipleLocationsDetailsBar';
import {
  styledCheckboxHeader,
  styledColumnHeaderCheckbox,
  styledColumnItem
} from '../../../components/layout/main/mainStyles';
import { selectSystemLocationsReadWrite } from '../../../store/slices/systemPermissions/systemPermissions';
import { AllLocationsFilters } from './allLocationsFilters/allLocationsFilters';
import { ShareLocationsWithTargets } from '../shareLocationsWithTargets/shareLocationsWithTargets';

export const AllLocationsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const filtersCount = Array.from(queryParams.keys()).length;
  const filterByLabel = queryParams.get('filterByLabel');
  const filterByOwner = queryParams.get('filterByOwner');
  const filterSharedWith = queryParams.get('filterSharedWith');
  const [allLocationsList, setAllLocationsList] = useState<Location[]>([]);
  const [openSideBar, setOpenSideBar] = useState(false);
  const [openSharedWithDialog, setOpenSharedWithDialog] = useState(false);
  const [selectToShowSharedWith, setSelectToShowSharedWith] =
    useState<Location>();
  const permissionLocationReadWrite = useSelector(
    selectSystemLocationsReadWrite
  );
  const [selectedLocations, setSelectedLocation] = useState<Location[]>([]);
  const [getLocations, { isLoading, isSuccess, data }] =
    useGetLocationsMutation();
  const [sideBarView, setSideBarView] = useState(
    viewRightSideBarEnum.addLocation
  );

  useEffect(() => {
    getLocations('');
  }, []);

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(setAllLocations(data));
    }
  }, [isSuccess]);

  const openLocationSideBarFor = (view: number) => {
    setOpenSideBar(true);
    setSideBarView(view);
  };

  const selectLocation = (params: any) => {
    navigate(`/locations/${params.id}/applications`);
  };
  const getStatus = (item: any) => {
    return <StatusProcess IsActive={item.enabled} marginRight={2} />;
  };

  const getName = (item: any) => {
    return (
      <StyledButtonName onClick={() => selectLocation(item)}>
        {item.name}
      </StyledButtonName>
    );
  };

  const reloadTablesAnCloseSidebar = () => {
    getLocations('');
    setOpenSideBar(false);
  };
  const switchSideBar = () => {
    const locations: LocationByUser[] = selectedLocations.map((element) => ({
      locationId: element.id,
      locationName: element.name,
      locationAddress: '',
      locationRemoteAccessToken: '',
      isOwner: false,
      ownerEmail: '',
      organizationId: 0,
      organizationName: '',
      locationRoleId: 0
    }));
    switch (sideBarView) {
      case viewRightSideBarEnum.addLocation:
        return (
          <AddLocationBar
            reloadTable={() => {
              reloadTablesAnCloseSidebar();
            }}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.locationDetails:
        return (
          <LocationDetailsBar
            openRightSideBarForMethod={openLocationSideBarFor}
            reloadTable={() => {
              reloadTablesAnCloseSidebar();
            }}
            locationOrg={locations[0] ?? []}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.shareLocation:
        return (
          <ShareLocationBar
            reloadTable={() => reloadTablesAnCloseSidebar()}
            selectedLocations={locations.map((loc) => loc.locationId) ?? []}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.shareLocationsWithTargets:
        return (
          <ShareLocationsWithTargets
            reloadTable={() => reloadTablesAnCloseSidebar()}
            selectedLocations={locations.map((loc) => loc.locationId) ?? []}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.transferLocation:
        return (
          <TransferLocationBar
            reloadTable={() => reloadTablesAnCloseSidebar()}
            selectedLocations={locations.map((loc) => loc.locationId) ?? []}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.moveLocation:
        return (
          <MoveLocationBar
            reloadTable={() => reloadTablesAnCloseSidebar()}
            idLocations={locations.map((loc) => loc.locationId) ?? []}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.multipleLocationsDetails:
        return (
          <MultipleLocationsDetailsSideBar
            reloadTable={() => reloadTablesAnCloseSidebar()}
            openRightSideBarForMethod={openLocationSideBarFor}
            selectedLocations={locations.map((loc) => loc.locationId) ?? []}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
      case viewRightSideBarEnum.allLocationsFilters:
        return (
          <AllLocationsFilters
            reloadTable={() => reloadTablesAnCloseSidebar()}
            setOpenRightSideBar={setOpenSideBar}
            openRightSideBar={openSideBar}
          />
        );
      default:
        return (
          <AddLocationBar
            reloadTable={() => getLocations('')}
            setOpenRightSideBar={setOpenSideBar}
          />
        );
    }
  };
  useEffect(() => {
    if (isSuccess && data) {
      let filteredLocations = data;
      if (filterByLabel) {
        const lowerCaseFilter = filterByLabel.toLowerCase();
        filteredLocations = data.filter((location) => {
          return (
            location.name.toLowerCase().includes(lowerCaseFilter) ||
            location.ownerEmail.toLowerCase().includes(lowerCaseFilter) ||
            location.locationAddress.toLowerCase().includes(lowerCaseFilter) ||
            location.organizationName.toLowerCase().includes(lowerCaseFilter)
          );
        });
      }
      if (filterByOwner) {
        filteredLocations = filteredLocations.filter((location) => {
          return (
            location.name.toLowerCase().includes(filterByOwner.toLowerCase()) ||
            location.ownerEmail
              .toLowerCase()
              .includes(filterByOwner.toLowerCase())
          );
        });
      }
      if (filterSharedWith) {
        filteredLocations = filteredLocations.filter((location) => {
          return location.sharedWith.some((user) =>
            user.email.toLowerCase().includes(filterSharedWith.toLowerCase())
          );
        });
      }
      setAllLocationsList(filteredLocations);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (selectedLocations.length === 1) {
      openLocationSideBarFor(viewRightSideBarEnum.locationDetails);
    } else if (selectedLocations.length > 1) {
      openLocationSideBarFor(viewRightSideBarEnum.multipleLocationsDetails);
    } else {
      openLocationSideBarFor(viewRightSideBarEnum.empty);
      setOpenSideBar(false);
    }
  }, [selectedLocations]);
  const getHeaderCheckbox = () => {
    return (
      <Checkbox
        className="p-checkbox"
        style={{
          visibility: selectedLocations.length ? 'visible' : 'hidden',
          ...styledCheckboxHeader
        }}
        checked={
          (allLocationsList &&
            selectedLocations &&
            selectedLocations.length > 0) ??
          false
        }
        onChange={() => {
          setSelectedLocation([]);
        }}
      />
    );
  };
  const SharedWithButton = (rowData: Location) => {
    return (
      <ButtonIconStyled
        size="small"
        onClick={() => {
          setSelectToShowSharedWith(rowData);
          setOpenSharedWithDialog(true);
        }}
      >
        <Visibility />
      </ButtonIconStyled>
    );
  };
  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-1 col-sm-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-5 col-sm-4 text-center">
              <TitleStyled>{Strings.locations.allLocations}</TitleStyled>
            </div>
            <div className="col-6 col-sm-4 text-right">
              <ButtonIconStyled
                size="small"
                onClick={() => {
                  setOpenSideBar(true);
                  setSideBarView(viewRightSideBarEnum.addLocation);
                }}
              >
                <AddCircleOutline />
              </ButtonIconStyled>
              <ButtonIconStyled
                size="small"
                onClick={() => {
                  setOpenSideBar(true);
                  setSideBarView(viewRightSideBarEnum.allLocationsFilters);
                }}
              >
                <Badge badgeContent={filtersCount} color="warning">
                  <Tune />
                </Badge>
              </ButtonIconStyled>
            </div>
          </div>
        </ContainerStyled>
      </Header>

      <Box>
        {isLoading && <LoadingRowsComponent />}
        {isSuccess && data && (
          <DataTable
            selection={selectedLocations}
            selectionMode="checkbox"
            className="mt-3"
            rowHover
            value={allLocationsList}
            onSelectionChange={(e) => setSelectedLocation(e.value)}
            size="small"
            scrollable
            scrollHeight="100vh"
            paginator={allLocationsList && allLocationsList.length >= 50}
            selectionPageOnly
            rows={50}
            rowsPerPageOptions={[
              5,
              10,
              20,
              50,
              allLocationsList ? allLocationsList.length : 50
            ]}
            tableStyle={{
              padding: 0,
              margin: 0,
              fontSize: '14px'
            }}
          >
            <Column
              selectionMode="multiple"
              headerStyle={styledColumnHeaderCheckbox}
              header={getHeaderCheckbox}
              frozen
            />
            <Column
              field="enabled"
              header=""
              sortable
              body={getStatus}
              headerStyle={{ width: '1.5rem', textAlign: 'center' }}
            />
            <Column
              field="name"
              header="Name"
              sortable
              body={getName}
              style={styledColumnItem}
            />
            <Column
              field="owner"
              header="Owner"
              sortable
              style={styledColumnItem}
            />
            <Column
              field="address"
              header="Address"
              body={(rowData) => rowData.getInfo?.address || ''}
              sortable
              style={styledColumnItem}
            />
            <Column field="organizationName" header="Organization" sortable />
            <Column
              field="createdAt"
              body={(rowData) =>
                rowData.createdAt
                  ? moment(rowData.createdAt).format('YYYY MM DD - HH:mm:ss')
                  : '-'
              }
              header="Created At"
              sortable
              dataType="date"
            />
            <Column
              field="sharedWith"
              header="Shared With"
              sortable
              body={SharedWithButton}
            />
          </DataTable>
        )}
      </Box>
      <Dialog
        header="Shared With"
        visible={openSharedWithDialog}
        onHide={() => {
          setOpenSharedWithDialog(false);
        }}
        style={{ width: '50vw' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
      >
        {selectToShowSharedWith &&
          selectToShowSharedWith.sharedWith.map((user) => (
            <SharedWithItem key={user.email}>{user.email}</SharedWithItem>
          ))}
      </Dialog>
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchSideBar()}
      </RightSideBar>
    </>
  );
};
